module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAA/klEQVQ4T63Tv0rDUBQG8O9Qs2TvIwgidNHFhor2lUI4gUyZAjnJC6RTBV3i4Ou4JYOC0CVvcOQOF6T0Jje2d78/znf+EC70aK5TFMUyy7LD8T9vSFVJRBoiumbm7b8gg1RVtVfV5yAIojiOv2dDbdsuuq57BRC5EIOORjNI3/fvqno/hoxCeZ5fhWHY+iBOqGmaYBiGDwCrqUpsr05GE5E3Vd34Is6KROQFwJPB0jT98tm1kxXZ/gC488WcU7MT88Umx292iIjWAB6Y+ccVc/JE/mx1RESPLmwSMhXYOwOwdWFekI1TluWOiG6ZeTP71o4/1HV9kyTJ59mQq9m/cL1/E0ZhqrUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/back-gray.png
// module id = neZ7
// module chunks = 0